/**
 * Conversion toggle
 * Specific type of toggle which allows toggling between
 * SI and CON units easily
 */
import React from 'react';

import Selector from '@components/Selector';
import { ViewToggle } from '@components/ViewToggle';

import { useConversion } from '@hooks/useConversion';

import { getUnits } from '@utils/conversion';

interface ConversionToggleProps {
  type?: string;
  group: string | string[];
  disabled?: boolean;
  mui?: boolean;
}

const ConversionToggle: React.FC<ConversionToggleProps> = ({
  type,
  group,
  disabled,
  mui = false,
}) => {
  const {
    convert,
    state: { conversion },
  } = useConversion();
  const units = getUnits(type);
  const display = !type || (type && units.SI);

  const handleChangeSelection = () => {
    if (typeof group === 'string') {
      convert({ toggleType: group });
    } else {
      group.forEach((g) => convert({ toggleType: g }));
    }
  };

  if (!display) {
    return null;
  }

  if (mui) {
    return (
      <ViewToggle
        disabled={disabled}
        leftLabel={units.SI || 'SI'}
        rightLabel={units.CON || 'CON'}
        checked={
          (typeof group === 'string'
            ? conversion[group]
            : conversion[group[0]]) ?? false
        }
        onChange={handleChangeSelection}
      />
    );
  }

  return (
    <Selector
      changeSelection={handleChangeSelection}
      disabled={disabled}
      isSelected={
        (typeof group === 'string'
          ? conversion[group]
          : conversion[group[0]]) ?? false
      }
      leftLabel={units.SI || 'SI'}
      rightLabel={units.CON || 'CON'}
    />
  );
};

export default ConversionToggle;
